import React, { useState } from 'react';
import { AuthService as auth } from './services/firebase/firebaseServiceNEW';
import { Link, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useForm, Controller } from 'react-hook-form';
import Metatags from '../Metatags/Metatags';
import { getAndClearRedirectPath } from '../utils/redirectUtils';
function SignIn({ isSignUp }) {
  const navigate = useNavigate();
  const { handleSubmit, control, formState: { errors } } = useForm();

  const [showPassword, setShowPassword] = useState(false);

  async function SignInwithEmailAndPassword(values) {
    console.log('submit', values)
    Swal.fire({
      title: 'Logged In, please wait',
      html:
        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
      showConfirmButton: false,
      showCancelButton: false,
      focusConfirm: false,
    });
    const { user, error } = isSignUp ? await auth.SignUpWithEmailAndPassword(values) : await auth.SignInWithEmailAndPassword(values);
    if (error) {
      Swal.fire({
        icon: 'error',
        html: `<strong>${error ? error : 'Something happened in the log'}.</strong>`,
      });
    } else {
      await axios.post(`${process.env.REACT_APP_API_URL}`, {
        action: 'GetUserbyId', id: user.user.uid, email: user.user.email
      }).then(response => {
        console.log('response.data', response.data)
        
        // here we check redirect path.
        const redirectPath = getAndClearRedirectPath();
        
        if (redirectPath) {
          setTimeout(() => {
            Swal.close();
            navigate(redirectPath);
          }, 2000);
        } else {
          // Using the original redirect path
          if (response.data.data.profile_complete
            && response.data.data.profile_complete === true
            && response.data.data.userType !== 'Owner') {
            setTimeout(() => {
              Swal.close();
              navigate('/search');
            }, 2000);
          } else if (response.data.data.profile_complete
            && response.data.data.profile_complete === true || response.data.data.role === 'admin') {
            setTimeout(() => {
              Swal.close();
              navigate('/garages');
            }, 2000);
          } else {
            setTimeout(() => {
              Swal.close();
              navigate('/');
            }, 2000);
          }
        }
      })
    }
  }

  async function forgotPassword() {
    const result = await Swal.fire({
      title: 'Enter your email',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: async (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          Swal.showValidationMessage('Please enter a valid email address.');
          return false;
        }
        try {
          const resp = await auth.resetPassword(email);
          if (resp === true) {
            Swal.fire({
              icon: 'success',
              title: 'We have sent you a password reset email. Please check your inbox.',
            });
            return true;
          } else {
            fireError(resp);
            return false;
          }
        } catch (error) {
          fireError(error);
          return false;
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    });
  }

  function fireError(e) {
    Swal.fire({
      title: 'Ups....',
      text: `something happened ${e}`,
      icon: 'error',
    });
  }

  return (
    <>
      <Metatags
        title="RENT OUT YOUR GARAGE"
        description="Make money renting your garage for storage."
        keywords="Rent my garage, Rent out my garage, Garage for rent, Make money with garage, Extra garage income, Garage rental space"
      />
      <section className='sec-padding'>
        <div className='container'>
          <div className='col-md-6 mx-auto'>
            <h1>
              Sign {isSignUp ? 'up' : 'in'} with GarageXY
            </h1>
            <form onSubmit={handleSubmit(SignInwithEmailAndPassword)}>
              <div className="form-group row">
                <label className="form-label col-md-4" htmlFor="email">Email:</label>
                <div className="col-md-8">
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: 'Email Required',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Invalid email address'
                      }
                    }}
                    render={({ field }) => <input type="text" {...field} placeholder="Email" className="form-control" />}
                  />
                  {errors.email && <div className='text-danger'>{errors.email.message}</div>}
                </div>
              </div>
              <div className="form-group row">
                <label className="form-label col-md-4" htmlFor="password">Password:</label>
                <div className="col-md-8 absolute-icons">
                  <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{ required: 'Password Required' }}
                    render={({ field }) => (
                      <input
                        type={showPassword ? "text" : "password"}
                        {...field}
                        placeholder="Password"
                        className="form-control"
                      />
                    )}
                  />
                  <i className={`la la-${showPassword ? 'eye-slash' : 'eye'}`} onClick={() => setShowPassword((prev) => !prev)}></i>
                  {errors.password && <div className='text-danger'>{errors.password.message}</div>}
                </div>
              </div>
              <div className="form-submit">
                <button type="submit" className="btn btn-primary btn-lg">{isSignUp ? 'Sign Up' : 'Log In'}</button>
              </div>
            </form>

            {!isSignUp &&
              <Link className="h5" data-tab="register" onClick={forgotPassword}>Forgot password?</Link>
            }

            <Link to={isSignUp ? '/login' : '/sign_up'}>
              <h3 className='strong'>{isSignUp ? 'Already have an account? login' : "Don't have an account? join us"}</h3>
            </Link>
          </div>
        </div>
      </section>

    </>
  );
}

export default SignIn;
